import WebformsTypes from './webforms.types';

const INITIAL_STATE = {
	forms: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case WebformsTypes.LOAD_WEBFORMS:
			return {
				...state,
				forms: action.payload
			};
		default:
			return state;
	}
};
